module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lynx/lyn_lines-0cec3e3d4feb5706b3468a11e671ae14.gif";